import instance from './base.service';

export const login = async (email, password, rememberMe) => {
  try {
    const res = await instance.post('/login', { email, password, rememberMe });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const isLogged = () => {
  const cookieExistsAndNotBlank = (input) => /^(.*;)?\s*token\s*=\s*[^;]/.test(input);
  const token = cookieExistsAndNotBlank(document.cookie);
  if (!token) {
    return null;
  }
  return token;
};

export const logout = async () => {
  try {
    const res = await instance.post('/logout');
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};
